<div class="modal-header">
    <h4 class="modal-title pull-left">Confirm</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    Voulez-vous vraiment confirmer la suppression ?
</div>
<!-- Modal footer -->
<div class="modal-footer">
    <button type="button" (click)="confirmDelete()" class="btn btn-danger">Oui</button>
    <button type="button" (click)="activeModal.close()" class="btn btn-default">Non</button>
</div>
